import { EasyActiveComponent } from "wle-pp/tool/easy_tune/easy_object_tuners/components/easy_active_component.js";
import { AddPPToWindowComponent, AddWLToWindowComponent, AdjustHierarchyPhysXScaleComponent, AnalyticsManagerComponent, AudioManagerComponent, BenchmarkMaxPhysXComponent, BenchmarkMaxVisibleTrianglesComponent, CADisplayLeaderboardComponent, CharacterCollisionSystemComponent, ClearConsoleComponent, ConsoleVRToolComponent, CopyHandTransformComponent, CopyHeadTransformComponent, CopyPlayerTransformComponent, CopyReferenceSpaceTransformComponent, DebugArrayFunctionsPerformanceAnalyzerComponent, DebugFunctionsPerformanceAnalyzerComponent, DebugManagerComponent, DebugPPArrayCreationPerformanceAnalyzerComponent, DebugPPFunctionsPerformanceAnalyzerComponent, DebugTransformComponent, DebugWLComponentsFunctionsPerformanceAnalyzerComponent, DebugWLFunctionsPerformanceAnalyzerComponent, EasyLightAttenuationComponent, EasyLightColorComponent, EasyMeshColorComponent, EasyScaleComponent, EasySetTuneTargeetGrabComponent, EasySetTuneTargetChildNumberComponent, EasyTextColorComponent, EasyTransformComponent, EasyTuneImportVariablesComponent, EasyTuneToolComponent, EnableDebugComponent, EnableToolComponent, FingerCursorComponent, GamepadControlSchemeComponent, GamepadMeshAnimatorComponent, GetDefaultResourcesComponent, GetSceneObjectsComponent, GrabbableComponent, GrabberHandComponent, InitConsoleVRComponent, InitEasyTuneVariablesComponent, InputManagerComponent, MuteEverythingComponent, ObjectPoolManagerComponent, OverlapCursorComponent, PPGatewayComponent, PlayerLocomotionComponent, SaveManagerComponent, ScaleOnSpawnComponent, SetActiveComponent, SetEngineLogLevelComponent, SetHandLocalTransformComponent, SetHandRayLocalTransformComponent, SetHeadLocalTransformComponent, SetPlayerHeightComponent, SetTrackedHandJointLocalTransformComponent, ShowFPSComponent, ShowXRButtonsComponent, SpatialAudioListenerComponent, SwitchHandObjectComponent, ToggleActiveOnButtonPressComponent, ToolCursorComponent, TrackedHandDrawAllJointsComponent, TrackedHandDrawJointComponent, TrackedHandDrawSkinComponent, VirtualGamepadComponent, VisualManagerComponent } from "../index.js";

export function registerPPComponents(engine) {
    engine.registerComponent(
        AddPPToWindowComponent,
        AddWLToWindowComponent,
        AdjustHierarchyPhysXScaleComponent,
        AnalyticsManagerComponent,
        AudioManagerComponent,
        BenchmarkMaxPhysXComponent,
        BenchmarkMaxVisibleTrianglesComponent,
        CADisplayLeaderboardComponent,
        CharacterCollisionSystemComponent,
        ClearConsoleComponent,
        ConsoleVRToolComponent,
        CopyHandTransformComponent,
        CopyHeadTransformComponent,
        CopyReferenceSpaceTransformComponent,
        CopyPlayerTransformComponent,
        DebugPPArrayCreationPerformanceAnalyzerComponent,
        DebugArrayFunctionsPerformanceAnalyzerComponent,
        DebugFunctionsPerformanceAnalyzerComponent,
        DebugManagerComponent,
        DebugPPFunctionsPerformanceAnalyzerComponent,
        DebugTransformComponent,
        DebugWLComponentsFunctionsPerformanceAnalyzerComponent,
        DebugWLFunctionsPerformanceAnalyzerComponent,
        EasyLightAttenuationComponent,
        EasyLightColorComponent,
        EasyMeshColorComponent,
        EasyScaleComponent,
        EasySetTuneTargeetGrabComponent,
        EasySetTuneTargetChildNumberComponent,
        EasyTextColorComponent,
        EasyTransformComponent,
        EasyTuneImportVariablesComponent,
        EasyTuneToolComponent,
        EasyActiveComponent,
        EnableDebugComponent,
        EnableToolComponent,
        OverlapCursorComponent,
        FingerCursorComponent,
        GamepadControlSchemeComponent,
        GamepadMeshAnimatorComponent,
        GetDefaultResourcesComponent,
        GetSceneObjectsComponent,
        GrabbableComponent,
        GrabberHandComponent,
        InitConsoleVRComponent,
        InitEasyTuneVariablesComponent,
        InputManagerComponent,
        MuteEverythingComponent,
        ObjectPoolManagerComponent,
        PPGatewayComponent,
        PlayerLocomotionComponent,
        SaveManagerComponent,
        ScaleOnSpawnComponent,
        SetActiveComponent,
        SetEngineLogLevelComponent,
        SetHandLocalTransformComponent,
        SetHandRayLocalTransformComponent,
        SetHeadLocalTransformComponent,
        SetPlayerHeightComponent,
        SetTrackedHandJointLocalTransformComponent,
        ShowFPSComponent,
        ShowXRButtonsComponent,
        SpatialAudioListenerComponent,
        SwitchHandObjectComponent,
        ToggleActiveOnButtonPressComponent,
        ToolCursorComponent,
        TrackedHandDrawAllJointsComponent,
        TrackedHandDrawJointComponent,
        TrackedHandDrawSkinComponent,
        VirtualGamepadComponent,
        VisualManagerComponent
    );
}